import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";
import { Reveal } from "@/components/common/Reveal";

export const FaqSection = ({ faqs = FAQS, muted = false }) => (
  <section data-testid="faq-section" className={muted ? "bg-brand-soft" : "bg-white"}>
    <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20 lg:py-40">
      <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Frequently Asked Questions
          </span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl">
            Questions? <span className="italic text-brand-blue">Answered.</span>
          </h2>
          <p className="mt-6 text-brand-muted">
            Everything you need to know before your visit. Still have a question? Just call or
            WhatsApp us — we&apos;re happy to help.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-brand-line">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-lg font-medium text-brand-dark hover:text-brand-blue hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-brand-muted">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
